import { REQUESTOR } from '../constants';

export interface SpaceData {
  tenant: string;
}

export type SpacesResponse = Record<string, SpaceData>;

const BASE_PATH = 'https://mcs-cdn.prod.content-platform.vpsvc.com';

export default class MerchandisingContentServiceClient {
  async getSpaces(): Promise<SpacesResponse> {
    const response = await fetch(`${BASE_PATH}/space-locales?requestor=${REQUESTOR}`, {
      method: 'GET'
    });

    if (!response.ok) {
      throw new Error(`Error fetching spaces: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }
}
